import Seo from "@/components/seo/Seo";
import JsonLd from "@/components/seo/JsonLd";
import { breadcrumbLd, softwareApplicationLd } from "@/data/schema";
import PageHero from "@/components/layout/PageHero";
import DownloadHub from "@/components/home/DownloadHub";
import Faq from "@/components/home/FAQ";

export default function DownloadPage() {
    return (
        <>
            <Seo
                title="Pobierz aplikację"
                path="/download"
                description="Pobierz Groszownik na iOS i Android. Zeskanuj kod QR lub zapisz się na listę oczekujących, by otrzymać dostęp jako pierwszy i bonus PRO."
            />
            <JsonLd data={softwareApplicationLd} />
            <JsonLd data={breadcrumbLd([{ name: "Start", path: "/" }, { name: "Pobierz", path: "/download" }])} />
            <PageHero
                eyebrow="Pobierz"
                title="Miej księgowość w kieszeni"
                subtitle="Groszownik startuje na iOS i Androidzie. Zapisz się, a damy Ci znać jako pierwszym."
            />
            <DownloadHub />
            <Faq />
        </>
    );
}
